import {closeDialog, useDialogStore} from '@ui/overlays/store/dialog-store';
import {DialogTrigger} from '@ui/overlays/dialog/dialog-trigger';
import React from 'react';

export function DialogStoreOutlet() {
  const {dialog: DialogElement, data} = useDialogStore();
  const overlayZIndex = getOverlayZIndex(data);

  return (
    <DialogTrigger
      type="modal"
      isOpen={DialogElement != null}
      zIndex={overlayZIndex}
      onClose={value => {
        closeDialog(value);
      }}
    >
      {DialogElement ? <DialogElement {...data} /> : null}
    </DialogTrigger>
  );
}

function getOverlayZIndex(data: unknown): number | undefined {
  if (!data || typeof data !== 'object') {
    return undefined;
  }

  const value = (data as {overlayZIndex?: unknown}).overlayZIndex;
  return typeof value === 'number' ? value : undefined;
}
